export default "images/profile-barkah.png";